import React from "react";
import { useQuickSightDevopsAgent } from "@/hooks/useDevopsAgentReports";
import AWSReportsTemplate from "@/components/templates/AWSReportsTemplate";
import QuickSightAwsDevopsAgentDashboard from "@/components/organisms/DevopsAgentDashboard";

function DevopsAgentReports() {
  const { embedUrl, loading, error, refetch } = useQuickSightDevopsAgent();

  return (
    <AWSReportsTemplate
      title="AWS DevOps Agent Dashboard"
      loading={loading}
      error={error}
      onRetry={refetch}
      hideFilters={true}
      hideDownload={true}
    >
      <QuickSightAwsDevopsAgentDashboard />
    </AWSReportsTemplate>
  );
}

export default DevopsAgentReports;
